import React from "react";
import "./param-table-editor-dialog.scss";

import HREditor from "./hr-editor";
import CmpxEditor from "./cmpx-editor/cmpx-editor";
import STEditor from "./st-editor/st-editor";
import dataCalculators from "../data-calculators";
class ParamTableEditorDialog extends React.Component {
    state = {};

    componentDidMount() {
        const {
            data: {
                HR,
                RR,
                RRmin,
                RRmax,
                S,
                P,
                PDur,
                QTmax,
                QTc,
                QTcAlg,
                QTcAvailableAlgs,
                QTcAlgVals,
                Q_next,
                angle_QRS,
                angle_P,
                angle_T,
                STDeprTo_uV,
                STElevTo_uV,
                transZone,
                indexSokolovLyon
            }
        } = this.props;
        const data = {
            HR,
            RR_ms: RR,
            angle_QRS,
            angle_P,
            angle_T,
            STDeprTo_uV,
            STElevTo_uV,
            transZone,
            indexSokolovLyon,

            RRmin_ms: RRmin,
            RRmax_ms: RRmax,

            QRS_ms: S,
            PQ_ms: P !== null ? -P : null,
            PDur_ms: PDur,

            QTmax_ms: QTmax,
            QTc_ms: QTc,
            QTcAlg,
            QTcAvailableAlgs,
            QTcAlgVals,
            Q_next_ms: Q_next
        };

        this.setState(data);
    }

    onChanged = (id, data) => {
        this.setState(oldState => dataCalculators(oldState, data, this.props.fd));
    };

    onSubmit = e => {
        e.preventDefault();

        const { onSave, onClose } = this.props;
        const savedData = this.prepareForOut(this.state);
        onSave(savedData);
        onClose();
    };

    onClose = () => {
        const { onClose } = this.props;
        const tempData = this.prepareForOut(this.state);
        onClose(tempData);
    };

    // ms_pnt = val => (val === undefined || val === null || val==="") ? null : val * this.props.fd / 1000;

    prepareForOut = data => {
        const outdata = {};
        const out = (_key, _keyOut, _val) => {
            if (data[_key] === undefined || data[_key] === null || _val === "") outdata[_keyOut] = null;
            else outdata[_keyOut] = _val;
        };
        let val = null;
        out("HR", "HR", data.HR);
        out("RRmin_ms", "RRmin", data.RRmin_ms);
        out("RRmax_ms", "RRmax", data.RRmax_ms);
        val = data.QRS_ms;
        out("QRS_ms", "S", val);
        val = data.PQ_ms;
        out("PQ_ms", "P", val && -val);
        out("PDur_ms", "PDur", data.PDur_ms);
        out("QTmax_ms", "QTmax", data.QTmax_ms);
        out("QTc_ms", "QTc", data.QTc_ms);
        out("angle_QRS", "angle_QRS", data.angle_QRS);
        out("angle_P", "angle_P", data.angle_P);
        out("angle_T", "angle_T", data.angle_T);
        out("STDeprTo_uV", "STDeprTo_uV", data.STDeprTo_uV);
        out("STElevTo_uV", "STElevTo_uV", data.STElevTo_uV);
        out("transZone", "transZone", data.transZone);
        out("indexSokolovLyon", "indexSokolovLyon", data.indexSokolovLyon);
        out("QTcAlg", "QTcAlg", data.QTcAlg);
        return outdata;
    };

    onCancel = () => {
        const { onClose } = this.props;
        onClose();
    };

    render() {
        const { loc } = this.props;

        if (Object.entries(this.state).length === 0 && this.state.constructor === Object) {
            return null;
        }

        const {
            HR,
            RRmin_ms,
            RRmax_ms,
            Q_next_ms,
            RR_ms,
            QRS_ms,
            PQ_ms,
            PDur_ms,
            QTmax_ms,
            QTc_ms,
            QTcAlg,
            QTcAvailableAlgs,
            angle_QRS,
            angle_P,
            angle_T,
            STDeprTo_uV,
            STElevTo_uV,
            transZone,
            indexSokolovLyon
        } = this.state;

        return (
            <div className="popup-window popup-window_opened table-params-popup-window">
                <button type="button" className="popup-close-btn" onClick={() => this.onClose()}>
                    &times;
                </button>

                <form id="TableParamsForm" action="#" onSubmit={this.onSubmit}>
                    <h3 className="form-header">{loc("dialogs.paramTable.title")}</h3>
                    <div className="form-content">
                        <HREditor data={{ HR, RRmin_ms, RRmax_ms }} onChanged={this.onChanged} />
                        <CmpxEditor
                            data={{
                                QRS_ms,
                                PQ_ms,
                                PDur_ms,
                                QTmax_ms,
                                QTc_ms,
                                angle_QRS,
                                QTcAlg,
                                QTcAvailableAlgs,
                                angle_P,
                                angle_T,
                                RR_ms,
                                Q_next_ms
                            }}
                            onChanged={this.onChanged}
                        />
                        <STEditor data={{ STDeprTo_uV, STElevTo_uV, transZone, indexSokolovLyon }} onChanged={this.onChanged} /> {/**/}
                    </div>
                    <div className="form-footer">
                        <input type="submit" className="button button-ok" value={loc("buttons.ok")} />
                        <input
                            type="reset"
                            className="button button-cancel"
                            value={loc("buttons.cancel")}
                            onClick={() => this.onCancel()}
                        />
                    </div>
                </form>
            </div>
        );
    }
}

export default ParamTableEditorDialog;
